export default __webpack_public_path__ + "static/media/Ethel with all 6 kids holding Betty.694e3c0c.jpg";